import { Helmet } from "react-helmet-async";

function SEO({ title, description }) {
  return (
    <Helmet>
      <title>{title}</title>

      <meta
        name="description"
        content={description}
      />

      <meta
        name="keywords"
        content="
        garden cleaning kerikeri,
        gardener kerikeri,
        garden maintenance kerikeri,
        car wash kerikeri,
        car cleaning kerikeri,
        car detailing kerikeri
        "
      />
    </Helmet>
  );
}

export default SEO;